import { Button } from "primereact/button";
import { useState } from "react";
import {
  genElDateObject,
  genElObject,
} from "@components/utils/EditorDialogElementGenerator";
import DepartmentSelectorDialog from "../../../dialogs/selectors/DepartmentSelectorDialog";
import JenisMinyakSelectorDialog from "../../../dialogs/selectors/JenisMinyakSelectorDialog";

// The filter picks one sheet of the paper form: department + jenis minyak + month.
const KartuStokMinyakFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;

  const [showDepartmentSelector, setShowDepartmentSelector] = useState(false);
  const [showJenisMinyakSelector, setShowJenisMinyakSelector] = useState(false);

  // handle ui event section

  const handleOnConfirmDepartment = (event, datas) => {
    if (datas && datas.length > 0) {
      const department = datas[0];
      setFilterValue((prevData) => ({
        ...prevData,
        data_department: department,
        department_id: department.id,
      }));
      setShowDepartmentSelector(false);
    }
  };

  const handleOnConfirmJenisMinyak = (event, datas) => {
    if (datas && datas.length > 0) {
      const jenisMinyak = datas[0];
      setFilterValue((prevData) => ({
        ...prevData,
        data_jenis_minyak: jenisMinyak,
        jenis_minyak_id: jenisMinyak.id,
      }));
      setShowJenisMinyakSelector(false);
    }
  };

  // custom ui section

  const elDepartment = genElObject({
    field: "department_id",
    name: "Nama Department",
    value: filterValue.data_department ? filterValue.data_department.nama : "",
    onClick: () => setShowDepartmentSelector(true),
  });

  const elJenisMinyak = genElObject({
    field: "jenis_minyak_id",
    name: "Jenis Minyak",
    value: filterValue.data_jenis_minyak
      ? filterValue.data_jenis_minyak.nama
      : "",
    onClick: () => setShowJenisMinyakSelector(true),
  });

  const elBulan = genElDateObject({
    field: "bulan",
    name: "Bulan / Tahun",
    data: filterValue,
    setData: setFilterValue,
    primeFormat: "MM yy",
    month: true,
  });

  return (
    <div className="row-between-end gap-4 w-full">
      <DepartmentSelectorDialog
        title={"Pilih Department"}
        visible={showDepartmentSelector}
        onHide={() => setShowDepartmentSelector(false)}
        onConfirm={handleOnConfirmDepartment}
      />

      <JenisMinyakSelectorDialog
        title={"Pilih Jenis Minyak"}
        visible={showJenisMinyakSelector}
        onHide={() => setShowJenisMinyakSelector(false)}
        onConfirm={handleOnConfirmJenisMinyak}
      />

      {/* filter component section */}
      <div className="row-start-end gap-4 w-full flex-wrap">
        <div className="col-start-start w-full sm:w-[14rem]">
          {elDepartment}
        </div>
        <div className="col-start-start w-full sm:w-[14rem]">
          {elJenisMinyak}
        </div>
        <div className="w-full sm:w-[12rem]">{elBulan}</div>
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default KartuStokMinyakFilter;
